import {useEffect} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {useHistory, useParams} from 'react-router'

import {useTranslation} from '../../../../hooks/useTranslation'

import {OrderCancellationConfigurationDetails} from './components/OrderCancellationConfigurationDetails'
import {useOrderCancellationConfigsEditMutation} from './hooks/useOrderCancellationConfigsMutation'
import {useOrderCancellationConfigsQuery} from './hooks/useOrderCancellationConfigsQuery'
import {OrderCancellationConfig} from './types/OrderCancellationConfig'

export const OrderCancellationConfigurationEdit = () => {
  const {configId} = useParams<{
    configId?: string
  }>()

  const {t} = useTranslation()
  const history = useHistory()
  const orderCancellationConfigsMutation = useOrderCancellationConfigsEditMutation()

  const orderCancellationConfigQueryInfo = useOrderCancellationConfigsQuery()

  const methods = useForm<OrderCancellationConfig>({
    defaultValues: {} as OrderCancellationConfig,
    mode: 'onChange'
  })

  useEffect(() => {
    if (configId && orderCancellationConfigQueryInfo.data) {
      const config = orderCancellationConfigQueryInfo.data.find((config) => config.id === configId)
      if (config) {
        methods.reset(config)
      }
    }
  }, [configId, orderCancellationConfigQueryInfo.data, methods])

  const handleSaveButtonClick = async (data: OrderCancellationConfig) => {
    try {
      await orderCancellationConfigsMutation.mutateAsync(data)
    } finally {
      history.goBack()
    }
  }

  if (orderCancellationConfigQueryInfo.isLoading || !orderCancellationConfigQueryInfo.data) {
    return <div>{t('configurations.hconnect.orderCancellation.configurationDetails.loading')}</div>
  }

  return (
    <FormProvider {...methods}>
      <OrderCancellationConfigurationDetails
        configId={configId}
        onSaveButtonClick={methods.handleSubmit(handleSaveButtonClick)}
        isSubmitting={orderCancellationConfigsMutation.isLoading}
      />
    </FormProvider>
  )
}
